<template lang="pug">
  .operator-table__table {{qwerty}}
    vue-custom-scrollbar(
    class="table-wrapper"
      :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell
              .table__cell-content Администратор
            th.table__cell.fixed
              .table__cell-content

        tbody.table__body
          tr.table__row(v-for="item in tab_data")
            td.table__cell
              .table__cell-content {{item.name}}
            td.table__cell.fixed
              .table__cell-content
                label.checkbox--oval
                  input.checkbox--oval(type="checkbox" checked)
                  .checkbox--oval__icon
                router-link.button.button--edit(to="/administrator/managers-edit")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "admin-managers-table",
  props: ["tab_data"],
  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true,
      },
    };
  },
};
</script>
